<div *ngIf="apiLoaded | async">
  <!-- <google-map
    [center]="center"
    [zoom]="zoom"
    #map
  >
  </google-map> -->
</div>